import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ErrorDisplayedState } from "./errorDisplayedInterface";

const initialState: ErrorDisplayedState = {
  errorType: undefined,
  errorText: undefined,
};

const actionFailedSlice = createSlice({
  name: "actionFailed",
  initialState,
  reducers: {
    fieldInputError: (state, action: PayloadAction<ErrorDisplayedState>) => {
      state = { ...state, ...action.payload };
    },

    alertError: (state, action: PayloadAction<ErrorDisplayedState>) => {
      state = { ...state, ...action.payload };
    },
  },
});

export const { fieldInputError, alertError } = actionFailedSlice.actions;
export const actionFailed = actionFailedSlice.reducer;
